import React from 'react'
import { IconProps } from '../../../common/types'

const ChevronLeft: React.FC<IconProps> = () => {
  return (
    <svg fill="none" viewBox="0 0 16 16">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10 12.666 5.333 8 10 3.333"
      ></path>
    </svg>
  )
}

export default ChevronLeft
